import { extVideoEndPoint } from "../loader/variables"

export const mainHeroVariants = {
    initial: (i) => ({
        transform: `translate3d(0%, -100%, 0)`,
        opacity: 0
    }), animate: (i) => ({
        transform: `translate3d(0%, 0, 0)`,
        opacity: 1,
        transition: {
            duration: i[1] ? 1: 1,
            ease: [0.16, 1, 0.3, 1],
            delay: i[1] ? (extVideoEndPoint - 0.5) + (0.025  * i[0]) : (0.025 * i[0])
        }
    }), exit: (i) => ({
        transform: `translate3d(0%, -100%, 0)`,
        opacity: 0,
        transition: {
            duration: 0.75,
            ease: [0.16, 1, 0.3, 1],
            delay: 0.025 * i[0]
        }
    })
}

export const subHeroVariants = {
    initial: (i) => ({
        transform: `translate3d(0%, 100%, 0)`,
        opacity: 0
    }), animate: (i) => ({
        transform: `translate3d(0%, 0, 0)`,
        opacity: 1,
        transition: {
            duration: i[1] ? 1: 1,
            ease: [0.16, 1, 0.3, 1],
            delay: i[1] ? (extVideoEndPoint - 0.5) + (0.025  * i[0]) + i[2] : (0.025 * i[0]) + i[2]
        }
    }), exit: (i) => ({
        transform: `translate3d(0%, -100%, 0)`,
        opacity: 0,
        transition: {
            duration: 0.75,
            ease: [0.16, 1, 0.3, 1],
            delay: 0.025 * i[0]
        }
    })
}

export const itemFLVariants = {
    initial: (i) => ({
        transform: i[0] && !i[1] ? "translate3d(0, 20%, 0)" : null,
        opacity: i[0] && !i[1] ? 0 : 1
    }), animate: (i) => ({
        transform: i[0] && !i[1] ? "translate3d(0, 0%, 0)" : null,
        opacity: 1,
        transition: {
            duration: 0.5,
            delay: i[0] ? extVideoEndPoint - 0.5 + (0.1 * i[2]) : 0,
            ease: [0.16, 0, 0.3, 1]
        }
    })
}

export const tsScrollLineWrapperVariants = {
    initial: {
        transform: "translate3d(-40px, -50%, 0)",
        opacity: 0
    }, animate: (i) => ({
        transform: "translate3d(0, -50%, 0)",
        opacity: 1,
        transition: {
            duration: 1,
            delay: i ? extVideoEndPoint - 0.5 : 0,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: {
        transform: "translate3d(-40px, -50%, 0)",
        opacity: 0,
        transition: {
            duration: 0.65,
            ease: [0.87, 0, 0.13, 1]
        }
    }, projExit: {
        transform: "translate3d(-40px, -50%, 0)",
        opacity: 0,
        transition: {
            duration: 0.65,
            ease: [0.87, 0, 0.13, 1]
        }
    }
}